// extracted by mini-css-extract-plugin
export default {"alert":"alert--wdI7r","root":"root--Yn6sw"};